export class CommonUtils {
    static getMessages(data: any): string {
        if (data?.message) {
            return data.message;
        }
        else if (data?.messages) {
            const messages = data?.messages.map((msg: { message: any; }) => msg.message).join(', ');
            return messages;
        }
        return " "
    }

    static getFilenameFromContentDisposition(contentDisposition: string | null): string | null {
        if (contentDisposition) {
            const matches = /filename="([^"]*)"/.exec(contentDisposition);
            if (matches) {
                return matches[1];
            }
        }
        return "Material List.xlsx";
    }

    static toCamelCase(input: string): string {
        if (!input) {
            return '';
        }
        return input.toLowerCase()
            .split(' ')
            .map((word, index) => index === 0 ? word : word
                .charAt(0).toUpperCase() + word.slice(1))
            .join('');
    }

    static formatNumberWithCommas(value: number | string | null | undefined): string {
        if (value === null || value === undefined || value === '') return '';
        const s = String(value).trim();
        const [intPart, decPart] = s.replace(/[, \u00A0]/g, '').split('.');
        const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return decPart !== undefined ? `${withCommas}.${decPart}` : withCommas;
    }
}